import React, { useEffect } from "react";
import { copyToClipboard } from "../../../utils/copyToClipboard";

const Modal = ({ show, onClose, content }) => {
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.className === "modal-overlay") {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-content bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <button className="absolute top-2 right-2 text-gray-600" onClick={onClose}>
          <sl-icon name="x" />
        </button>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold">Rough Description</h3>
          {content && (
            <button onClick={() => copyToClipboard(content)} className="text-gray-400 hover:text-gray-600 transition" title="Copy Description">
              📋
            </button>
          )}
        </div>
        <pre className="whitespace-pre-wrap break-words font-mono text-gray-700 bg-gray-100 p-2 rounded-md text-lg">{content}</pre>
      </div>
    </div>
  );
};

export default Modal;
